import React from 'react'
import { Route } from 'react-router'
import { StandardLayout } from 'common/layouts/StandardLayout'
import { AdminDashboard } from '../AdminDashboard'
import { AdminExperiments } from '../AdminExperiments'
import { DeviceAnalytics } from '../DeviceAnalytics'
import { ExperiencesLookup } from '../ExperiencesLookup'

const Wrapper = ({ children }) => (
  <StandardLayout greyBg>
    {children}
  </StandardLayout>
)

export const routes = (
  <Route component={Wrapper}>
    <Route path='dashboard' component={AdminDashboard} />
    <Route path='experiments' component={AdminExperiments} />
    <Route path='device_analytics' component={DeviceAnalytics} />
    <Route path='experiences/lookup' component={ExperiencesLookup} />
  </Route>
)
